<template>
    <div >
        <v-group  ref="mygroup"
                  @dragend="handleDragEnd"
                  @dragmove="handleDragMove"
                 :config="{
                 name: obj.id,
                  x : obj.position.x,
                  y : obj.position.y,
                  }">
            <v-circle  :config="{
                        x: 0,
                        y: 0,
                        Radius: 120,
                        groupRef: obj.id,
                        stroke: '#8992a5',
                        fill:selectionned,
                        strokeWidth: hasChildren,
                        listening:false,
                        dash:[10,5]
                        }">

            </v-circle>
            <v-text v-if="hasChildren>0"
                    :config="{
                                  x : 130,
                                  y:-16,
                                  fill: '#8992a5',
                                  text: getChildrenText,
                                  fontSize:34,
                                  fontStyle:'bold',
                                    fontWeight:900,
                                  }"></v-text>


                    <v-rect name="circle"
                            ref="circle"
                            @dragstart="handleDragStart"
                            @mouseenter="cursorMove"
                            @mouseleave="cursorDefault"
                            @click="editTask"

                            :config="{
                                  x : -100,
                                  y: -50,
                                  width:200,
                                  height:100,
                                  groupRef: obj.id,
                                  radius: 50,
                                  fill: 'white',
                                  stroke: getDialStrokeColor,
                                  strokeWidth: getDialStorke,
                                  cornerRadius: getDialRadius,
                                  shadowColor: 'black',
                                  shadowBlur: 10,
                                  shadowOffset: { x: -5, y: 5 },
                                  shadowOpacity: this.opac,
                                  draggable: imAlive,
                                  }"></v-rect>
                    <v-text :config="{
                                  x : -200,
                                  y: -75,
                                  width:400,
                                  fill: 'black',
                                  text: labelUpper,
                                  fontSize:24,
                                  fontStyle:'bold',
                                  align:'center',
                                  }"></v-text>

            <v-text v-if="isDialogue"
                    :config="{
                                  x : -160,
                                  y:-25,
                                  fill: getDialColor,
                                  text: getDialIcon,
                                  fontSize:54,
                                  fontStyle:'bold',
                                  fontFamily:'FontAwesome',
                                  }"></v-text>


                    <v-text v-if="nothingIsMoving"
                            :config="{
                                  x : -90,
                                  y: -43,
                                  width:180,
                                  fill: 'black',
                                  text: getShortDesc,
                                  fontSize:12,
                                  fontStyle:'bold',
                                  padding:3,
                                  align:'left',
                                  listening:false,
                                  }"></v-text>

            <v-image v-if="nothingIsMoving"
                    @click="confirmDelete"
                    :config="{
                                  x : 104,
                                  y: -51,
                                  image:imgClose,
                                  }"></v-image>
            <v-image v-if="nothingIsMoving"
                     @click="goDeeper"
                     :config="{
                                  x : 104,
                                  y: -14,
                                  image:imgDeeper,
                                  }"></v-image>

            <v-image v-if="nothingIsMoving"
                    @click="addResultat"
                     :config="{
                                  x : -9,
                                  y: 35,
                                  image:imgAdd,
                                  }"></v-image>

            <resultat v-for="thing in resultats"
                              @reloadRes="updateResultats"
                              @linkChange="linkChange"
                              v-bind:res="thing"
                              :key="thing.id" ></resultat>

            <v-circle
                       ref="requis"
                             name="Requis"
                             @dragenter="collisionStart"
                             @dragout="collisionStop"
                             :config="{
                                        x: 0,
                                        y: -95,
                                        Radius: 15,
                                        groupRef: obj.id,
                                        fill: '#E6A23C',
                                        stroke: '#606266',
                                        strokeWidth: 1,
                                        listening:true,
                                        }">

                    </v-circle>
        </v-group>
    </div>
</template>

<script>
    import Resultat from './Resultat.vue';
    import RClass from '../classes/Resultat';
    import Lien from '../classes/Lien';

    import _ from 'lodash';

export default{
    name:'tache',
    data (){
        return {
            myStage:'',
            opac:0.2,
            isDragging:false,
            mustSavePos:false,
            redLine:'',
            lastCollision:'',
            linkIsLoaded:false,
            imgClose:null,
            imgAdd:null,
            imgDeeper:null,

            selectionned:'',

            resultats:[],

            nbChildren:0,

            isLoaded:false,
        };
    },
    props:[ 'obj' ],
    components:{
        Resultat
    },
    computed:{


        isDialogue(){
            return this.obj.type==='DIAL' ? true : false
        },

        getDialIcon(){
            const element=this.$store.getters.getElementId(this.obj.data.label)[0]

            if(element)
                return this.getUnicode(element.icone)
            else
                return "\uf128"
        },
        getDialColor(){
            const element=this.$store.getters.getElementId(this.obj.data.label)[0]

            if(element)
                return element.color
            else
                return "black"
        },
        getDialStorke(){
            return this.obj.type==='DIAL' ? 15 : 2
        },
        getDialRadius(){
            return this.obj.type==='DIAL' ? 20 : 0
        },
        getDialStrokeColor(){
            return this.obj.type==='DIAL' ? this.getDialColor : "#606266"
        },


        //Flag : On dessine que si rien ne bouge
        nothingIsMoving(){
            return !this.$store.getters.isSomeThingMoving
        },


        hasChildren(){
            if(this.nbChildren>0)
                return 5
            else
                return 0
        },
        getChildrenText(){
            let leNom=this.$store.getters.getLevelName[this.obj.level+2]
            if(!leNom)
                leNom='Action'

          const txt='> '+this.nbChildren+' '+leNom+'(s)'
            return txt
        },

        storeGetElement(){
            if(this.obj.type==='DIAL')
                return this.$store.getters.getElementId(this.obj.data.label)
            else
                return this.obj.data.label
        },

        getStoreMessage(){
          return this.$store.getters.getTaskMessage
        },


        theNode(){
            return this.$refs.mygroup.getNode()
        },

        reference: () => {
            return this.obj.ref;
        },
        storeGetAllLinkMe() {
            return this.$store.getters.storeGetAllLinkMe(this.obj.id)
        },
        storeGetLinkFromMe() {
            return this.$store.getters.storeGetLinkFromMe(this.obj.id)
        },

        getScale () {
            return this.$store.getters.getScale;
        },
        getShortDesc()
        {
            return this.obj.data.description.slice(0,210)
        },
        imAlive(){
            let alive=true
            if(this.obj.data.reload==1){
                this.$emit('reload')
                alive=false
            }
            return alive
        },
        labelUpper(){
            if(this.obj.type==='DIAL'){
                if(this.storeGetElement[0])
                    return  _.toUpper(this.storeGetElement[0].nom)
                else
                    return "Choisir qui parle"
            }
            else
                return _.toUpper(this.obj.data.label)
        }
    },
    methods:{
        storeGetLinkFromTo(from,to){
            return this.$store.getters.storeGetLinkFromTo(from,to)
        },
        storeGetLinkFromToInverse(from,to){
            return this.$store.getters.storeGetLinkFromToInverse(from,to)
        },

        async getNbChild()
        {
          this.nbChildren=await this.$mydb.do.countChildrenOfTask(this.obj.id)
        },

        handleDragStart(evt) {

            //Pour que le cercle declenche le Drag mais que ce soit le groupe qui bouge
            this.$refs.circle.getNode().stopDrag();
            const theGroup=this.$refs.mygroup.getNode();
            const theStage=evt.target.getStage();

            //Recentre le group sur le pointeur de la souris
            const pos = theStage.getPointerPosition();

            theGroup.setAttrs({
                x: (pos.x -theStage.x())/this.getScale,
                y: (pos.y -theStage.y())/this.getScale,
            });

            //Pour mettre tout ca en premier plan
            theGroup.moveTo(theStage.find('.DragLayer')[0]);
            theStage.draw(); //Force un refresh du graph
            theGroup.startDrag();

            //On fait apparaitre l'ombre
            this.opac=0.8;
            this.isDragging = true;

            //on active la sauve de pos
            this.mustSavePos=true;

            this.$store.commit('SET_MOVING',true)
            let layer = theStage.find('.linkLayer')[0]
            layer.hitGraphEnabled(false)
        },

        handleDragMove() {

            //const src=this.$refs.mygroup.getNode();
            this.$store.commit('UPDATEPOS_TO',[this.obj.id,this.theNode.x(),this.theNode.y()]);
            //this.$store.dispatch('updateThePos',[this.obj.id,src.x(),src.y()])
        },

        handleDragEnd(evt) {
            if(this.mustSavePos) {

                this.isDragging = false;

                //On ramene le group dans le layer de base
                const theStage = evt.target.getStage();
                const theGroup = this.$refs.mygroup.getNode();
                theGroup.moveTo(theStage.find('.Layer')[0]);
                theStage.draw(); //Force un refresh du graph

                //Save nvl position
                const pos = theStage.getPointerPosition();
                pos.x=(pos.x -theStage.x())/this.getScale,
                pos.y=(pos.y -theStage.y())/this.getScale,
                this.savePos(pos);

                //on fait disparraitre l'ombre
                this.opac = 0.2;
                this.mustSavePos=false;

                this.$store.commit('SET_MOVING',false)
                let layer = theStage.find('.linkLayer')[0]
                layer.hitGraphEnabled(true)
            }
        },



    //*****************************************************
    // Evenements en procédure de création de liens
    //*****************************************************

        collisionStart(evt)
        {
            evt.target.attrs.radius=30;
            evt.target.getStage().draw()
        },
        collisionStop(evt)
        {
            evt.target.attrs.radius=11;
            evt.target.getStage().draw()
        },



    //****************************************************
    // Decoration
    //****************************************************

        cursorMove(evt)
        {
            evt.target.getStage().container().style.cursor = 'move';
            evt.target.attrs.strokeWidth+=2;
            evt.target.getStage().draw();

            this.$store.commit('SET_FOCUS',{level:this.obj.level,parent:this.obj.id,label:this.labelUpper})
        },
        cursorDefault(evt)
        {
            evt.target.getStage().container().style.cursor = 'default';
            evt.target.attrs.strokeWidth-=2;
            evt.target.getStage().draw();
            this.$store.commit('SET_FOCUS','')
        },

    //****************************************************
    // DATABASE
    //****************************************************

        async savePos(value) {
            this.obj.position=value;
            if(this.mustSavePos)
                await this.$mydb.do.updateTaskPos(this.obj.id,value);
        },

        async deleteTask(){

            await this.$store.dispatch('delTask',this.obj.id)

            //switch sidebar
            const toEdit={
                name:'TabHelp',
                config:''
            }
            this.$store.commit('DROITE_SET',toEdit);

            //Emettre l'évenement "reload"
            this.$emit('reload')
        },

        editTask(){
            let target='TabTache'
            if(this.obj.type==='DIAL')
                target='TabDialogue'

            const toEdit={
                name:target,
                config:this.obj
            }
            this.$store.commit('DROITE_SET',toEdit);
            console.log(this)
        },

        goDown(){
          alert("yop")
        },

        async addResultat(){

            const tmp=new RClass(this.obj.id,false)
            if(this.obj.type==="DIAL"){
                tmp.type='DIAL'
                tmp.data.label="Réponse"
            }
            tmp.data.label=tmp.data.label+' #'+(this.resultats.length+1)
            await this.$mydb.do.saveResultat(tmp);
            await this.getResultats()



            const toEdit={
                name:'TabResultat',
                config:this.resultats[this.resultats.length-1]
            }
            this.$store.commit('DROITE_SET',toEdit);
        },

        updateResultats(){
            this.getResultats()
        },

        async getResultats(){

            const taskRef= this.obj.id
            const result= await this.$mydb.do.getResultatOutOf(taskRef)

            const nb=result.length
            if(result) {
                 for (let [index, val] of result.entries() ) {
                     val.y=100
                     if(nb==1)
                         val.x=0
                     else
                        val.x=20+(index)*40 - (nb)*20
                 }
                 this.resultats=result
            }
            this.isLoaded=true
        },

        linkChange(evt)
        {

            this.getLink()
            this.getResultats()

            this.$store.commit('UPDATE_TASK_LINK',evt)
        },

        async getLink() {

            //console.log("getLink of"+this.obj.id)
             const taskRef=this.obj.id
            const result=await this.$mydb.do.getLinkOutOf(taskRef)

            //clean le store
            this.linkIsLoaded=false
            this.$store.commit('DELETE_LINKFROM',taskRef)

           // console.log(this.$refs.mygroup)
            //console.log(this)
            const src = this.$refs.mygroup.getNode();

             if(result) {

                 for (const myLink of result) {

                     const nb=await this.$mydb.do.countLinkToAndFrom(taskRef,myLink.to)

                     let separe=0.5
                     if(nb[0]>0 && nb[1]>0)
                         separe=1


                     const dst = this.$refs.mygroup.getNode().getStage().find("." + myLink.to)[0];

                     //On regarde s'il existe deja des lien sur le meme emplacement pour decaler s'il le faut
                     let check=this.storeGetLinkFromTo(myLink.from,myLink.to).length
                     // if(this.storeGetLinkFromToInverse(myLink.from,myLink.to).length>0)
                     //      check+=0.5

                     if (src && dst) {
                         const newLink=new Lien(myLink.from,myLink.fromExact,myLink.to)
                         newLink.id= myLink.id
                         newLink.points= [src.x(), src.y(), dst.x(), dst.y()]
                         newLink.type=myLink.type
                         newLink.data=myLink.data
                         newLink.data.decale=separe+check -(nb[0]-(nb[0]+nb[1])/2)


                         if (myLink.from == this.obj.id) {
                             if (!this.linkIsLoaded)
                                 this.$store.commit('ADDLINK', newLink);
                         }
                     }
                 }
             }
             this.linkIsLoaded=true;
            return true
        },

        goDeeper(){

            this.$store.commit('SET_FOCUS',{level:this.obj.level,parent:this.obj.id,label:this.labelUpper})

            this.$emit('goDeeper')
        },

        //**********************************************************
        // DIFFERENTES ALERTES
        //**********************************************************
        alertCustomError(msg) {
            this.$dialog.alert({
                title: 'Error',
                message: msg,
                type: 'is-danger',
                hasIcon: true,
                icon: 'alert-circle-outline',
                iconPack: 'mdi'
            })
        },

        getUnicode(name) {
            var testI = document.createElement('i');
            var char;

            testI.className = 'fa fa-' + name;
            document.body.appendChild(testI);

            char = window.getComputedStyle( testI, ':before' )
                .content.replace(/'|"/g, '');

            testI.remove();

            return String.fromCharCode("0x" + char.charCodeAt(0).toString(16));
        },


        confirmDelete() {
            this.$dialog.confirm({
                title: 'Effacer ce noeud ?',
                message: 'Attention! cela va effacer tout ce qu\'il contient...',
                confirmText: 'EFFACE',
                cancelText: 'Annuler',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => this.deleteTask()
            })
        }



    },


    created() {
        const image = new window.Image();
        image.src = "close.png";
        image.onload = () => {
            // set image only when it is loaded
            this.imgClose = image;
        };

        const imageB = new window.Image();
        imageB.src = "add.png";
        imageB.onload = () => {
            // set image only when it is loaded
            this.imgAdd = imageB;
        };

        const imageC = new window.Image();
        imageC.src = "deeper.png";
        imageC.onload = () => {
            // set image only when it is loaded
            this.imgDeeper = imageC;
        };
    },

    updated(){

    },
    destroyed(){
      console.log("destroyed")
    },
    watch: {
        getStoreMessage(newValue, oldValue) {


            if(newValue!=oldValue)
            {
                if(newValue.sidebar.config.id===this.obj.id)
                {
                    this.selectionned="#CCCCCC"
                    this.$store.commit('SET_FOCUS',{level:this.obj.level,parent:this.obj.id,label:this.labelUpper})
                }
                else //if(oldValue.config.ref===this.obj.ref)
                {
                    this.selectionned=""
                }

                if(newValue.reload===this.obj.id)
                {
                    this.isLoaded=false
                    console.log(this)
                    this.getLink()
                    this.getResultats()
                    this.$store.commit('UPDATE_TASK_LINK','')

                }
            }


        }
    },

    mounted(){

        this.getResultats()
        this.getLink()
        this.getNbChild()

        // this.$store.watch(
        //     (state, getters) => getters.getTaskMessage,
        //     (newValue, oldValue) => {
        //         if(newValue!=oldValue)
        //         {
        //             if(newValue.sidebar.config.id===this.obj.id)
        //             {
        //                 this.selectionned="#CCCCCC"
        //                 this.$store.commit('SET_FOCUS',{level:this.obj.level,parent:this.obj.id,label:this.labelUpper})
        //             }
        //             else //if(oldValue.config.ref===this.obj.ref)
        //             {
        //                 this.selectionned=""
        //             }
        //
        //             if(newValue.reload===this.obj.id)
        //             {
        //                 this.isLoaded=false
        //                 console.log(this)
        //                 this.getLink()
        //                 this.getResultats()
        //                 this.$store.commit('UPDATE_TASK_LINK','')
        //
        //             }
        //         }
        //
        //     },
        // );


    }
}
</script>

<style lang="scss">

   // @import "../assets/css/font";




</style>